export default __webpack_public_path__ + "static/aboutus5-45046799b76e096ed32d0ae48b83a1b3.png";